import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "typed-redux-saga";

import { ModelActions } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import { ModelGraph } from "@com.mgmtp.a12.dataservices/dataservices-access/lib";
import { UaaActions } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { fetchFromServerConnector } from "../../utilities/restHelper";

export function* LoadModelGraphSaga(): SagaIterator<void> {
	yield* takeLatest(UaaActions.loggedIn, LoadModelGraphWorker);
}

function* LoadModelGraphWorker(): SagaIterator<void> {
	const modelGraph = yield* call(fetchFromServerConnector, ModelGraph.build());
	yield* put(ModelActions.setModelGraph(modelGraph as ModelGraph));
}
